import { EMoneySource } from '../../types/reducers/user';

import { EMoneySourceWidgetType } from './types';
import { MoneySourceTabs } from './components/MoneySourceTabs';
import { MoneySourceButtons } from './components/MoneySourceButtons';

export const ANALYTIC_LABEL_BY_MONEY_SOURCE: Record<EMoneySource, 'Agent' | 'Personal'> = {
  [EMoneySource.Master]: 'Agent',
  [EMoneySource.Self]: 'Personal',
};

type TTabLabels = Record<EMoneySource, 'Со счёта агентства' | 'С личного счёта'>;
type TButtonLabels = Record<EMoneySource, 'Агентство' | 'Личный'>;
type TOptionsMap = {
  [EMoneySourceWidgetType.Tabs]: TTabLabels;
  [EMoneySourceWidgetType.Buttons]: TButtonLabels;
};

export const MONEY_SOURCE_OPTION_LABELS_BY_TYPE: TOptionsMap = {
  [EMoneySourceWidgetType.Tabs]: {
    [EMoneySource.Master]: 'Со счёта агентства',
    [EMoneySource.Self]: 'С личного счёта',
  },
  [EMoneySourceWidgetType.Buttons]: {
    [EMoneySource.Master]: 'Агентство',
    [EMoneySource.Self]: 'Личный',
  },
};

type TWidgetComponent = typeof MoneySourceTabs | typeof MoneySourceButtons;

export const MONEY_SOURCES_WIDGET_BY_TYPE: Record<EMoneySourceWidgetType, TWidgetComponent> = {
  [EMoneySourceWidgetType.Tabs]: MoneySourceTabs,
  [EMoneySourceWidgetType.Buttons]: MoneySourceButtons,
};
